import * as actionTypes from './actionTypes'
import { sellService } from '../../service'
import { errorHelper } from '../../common/helpers'
import { constants } from '../../common/constants'

export function getSells({ page = constants.GET_ALL_ITEMS, filter, reset } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_SELLS })

            dispatch({ type: actionTypes.FETCH_SELLS })

            const response = await sellService.getAll(page, filter)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_SELLS_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_SELLS_SUCCESS,
                payload: {
                    sells: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_SELLS_FAILURE)
        }
    }
}

export function getItemListByPrefix(prefix, reset) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_ITEMS_LIST })
            dispatch({ type: actionTypes.FETCH_ITEMS_LIST })

            const response = await sellService.getItemListByPrefix(prefix)
            const data = response.data
            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_ITEMS_LIST_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_ITEMS_LIST_SUCCESS,
                payload: {
                    items: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_SELLS_FAILURE)
        }
    }
}

export function getSell(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_SELL })
            dispatch({ type: actionTypes.FETCH_SELL })

            const response = await sellService.get(id)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_SELL_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_SELL_SUCCESS,
                payload: { sell: data }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_SELL_FAILURE)
        }
    }
}


export function getIGV() {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.FETCH_IGV })

            const response = await sellService.getIGV()

            dispatch({
                type: actionTypes.FETCH_IGV_SUCCESS,
                payload: { igv: response.data }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_IGV_FAILURE)
        }
    }
}

export function addSell(params, sell) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.ADD_SELL })
            const response = await sellService.addSell(params, sell)
            dispatch({
                type: actionTypes.ADD_SELL_SUCCESS,
                payload: { sell: response.data }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.ADD_SELL_FAILURE)
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/sell/actions.js